module.exports = __webpack_public_path__ + "static/orderstatus-list-13c6d115fd2df68f6449c2ead5604c1b.png";